import { Button } from "react-bootstrap";
import CloseIcon from "./closeIcon";

const Drawer = ({
    title,
    children
}) => {
    return (
        <div>
            <div className="tw-fixed tw-h-full tw-w-full tw-top-0 tw-left-0 tw-z-10 tw-bg-black tw-opacity-60"></div>
            <div className="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-bg-white tw-h-2/3 tw-z-20 tw-rounded-tr-2xl tw-rounded-tl-2xl">
                <hr className="tw-w-10 tw-h-[5px] tw-mt-2 tw-top-0 tw-left-0 tw-rounded-sm tw-bg-medium-gray tw-opacity-60 tw-mx-auto" />
                <div className="!tw-h-[calc(100%-110px)] !tw-pb-4 tw-overflow-y-scroll">
                    <div className="tw-pt-5 tw-p-4 tw-text-2xl tw-font-bold !tw-text-main">
                        {title}
                        <span className="tw-float-right tw-cursor-pointer" >
                            <CloseIcon />
                        </span>
                    </div>
                    {children}
                </div>
                <div className="tw-absolute tw-w-full tw-z-10 tw-bottom-0 tw-p-4">
                    <Button
                        className="tw-w-full tw-cursor-pointer tw-rounded-lg tw-block tw-text-center tw-text-sm
                        tw-bg-main tw-text-white tw-py-4"
                    >
                        Done
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default Drawer;